export default __webpack_public_path__ + "schoolBuilding.3ca5721.png";